import { render, staticRenderFns } from "./PronunciationRecorder.vue?vue&type=template&id=170d805c&lang=pug&"
import script from "./PronunciationRecorder.vue?vue&type=script&lang=js&"
export * from "./PronunciationRecorder.vue?vue&type=script&lang=js&"
import style0 from "./PronunciationRecorder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports